import React from 'react';
import './BlogCard.css'
import Btn from './Btn';

const BlogCard = (props) => {
    return ( 
        <div className='BlogCard'>
            <div className='BCardDate'>
                <p className='Year'><span className='Day'>{props.Day}</span> <br /> {props.Year}</p>
            </div>
            <img className='BCardImg' src={props.BCardImg} alt="" />

            <div className='BCardInfo'>
                <p className='BCardTitle'>{props.BCardTitle}</p>
                <p className='BCardP'>{props.BCardP}</p>
            </div>
            <Btn BtnText='Read More' BtnStyle='BuyBtn'/>
        </div>
     );
}
 
export default BlogCard;